import { ApiService } from '@kaiser-software/chassis-core';
import { LocationModel } from '../models/location.model';

export class TenantLocationService extends ApiService {

    public restEndpoint = 'tenants/{tenant}/locations';

    public entityName = 'tenant';

    public model = LocationModel;

}



// WEBPACK FOOTER //
// ./apps/eyewatch/src/app/eyewatch/locations/services/tenant-location.service.ts